/**
 * GM-режим: секрет тримається у localStorage під ключем 'gm-secret'.
 * Контекст переглядає його щохвилини, щоб не пропустити очистку з інших табів.
 */
const STORAGE_KEY = 'sd:gm-secret';

export function getGmSecret(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch { return null; }
}

export function setGmSecret(secret: string): void {
  try {
    if (secret) localStorage.setItem(STORAGE_KEY, secret);
    else localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new CustomEvent('sd:gm-changed'));
  } catch { /* noop */ }
}

export function isGm(): boolean {
  const s = getGmSecret();
  return !!s && s.length >= 8;
}

/**
 * Fetch wrapper, що додає X-GM-Secret якщо у нас є секрет. Уніфікований
 * парсер помилок: на не-OK кидає Error із текстом сервера.
 */
export async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const secret = getGmSecret();
  const headers: Record<string, string> = {
    Accept: 'application/json',
    ...(init?.headers as Record<string, string> | undefined),
  };
  if (secret) headers['X-GM-Secret'] = secret;
  if (init?.body && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }
  const res = await fetch(url, { ...init, headers });
  if (!res.ok) {
    let body: unknown = null;
    try { body = await res.json(); } catch { /* noop */ }
    const msg = (body as { message?: string; error?: string } | null)?.message
      ?? (body as { error?: string } | null)?.error
      ?? `${res.status} ${res.statusText}`;
    const err = new Error(msg) as Error & { status?: number };
    err.status = res.status;
    throw err;
  }
  if (res.status === 204) return undefined as T;
  return res.json() as Promise<T>;
}
